import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-status',
  templateUrl: './split-status.component.html',
  styleUrls: ['./split-status.component.scss']
})
export class SplitStatusComponent {
  @Input() status!: string;
  @Input() label?: string;
  @Input() style!: string;
}
